import { BaseComponent } from '../../types';
import { MockCard } from './MockCard';

interface DashboardMockProps extends BaseComponent {}

export function DashboardMock({ className }: DashboardMockProps) {
  return (
    <div
      className={`relative p-3 md:p-6 w-[23rem] md:w-[450px] md:h-[406px] rounded-3xl md:rounded-[32px] ${className || ''}`}
      style={{
        border: '1px solid rgba(148, 163, 184, 0.15)',
        background: 'rgba(30, 41, 59, 0.40)',
        boxShadow:
          '0 20px 60px 0 rgba(0, 0, 0, 0.50), 0 1px 0 1px rgba(255, 255, 255, 0.05) inset',
        backdropFilter: 'blur(10px)',
      }}
    >
      {/* Top Progress Bars */}
      <div className="grid grid-cols-3 gap-1 md:gap-2 mb-3 md:mb-6">
        <div
          className="h-2 rounded-sm"
          style={{
            gridRow: '1 / span 1',
            gridColumn: '1 / span 1',
            justifySelf: 'stretch',
            background:
              'linear-gradient(90deg, rgba(148, 163, 184, 0.30) 0%, rgba(148, 163, 184, 0.10) 100%)',
          }}
        />

        <div
          className="h-2 rounded-sm"
          style={{
            gridRow: '1 / span 1',
            gridColumn: '2 / span 1',
            justifySelf: 'stretch',
            background:
              'linear-gradient(90deg, rgba(148, 163, 184, 0.30) 0%, rgba(148, 163, 184, 0.10) 100%)',
          }}
        />

        <div
          className="h-2 rounded-sm"
          style={{
            gridRow: '1 / span 1',
            gridColumn: '3 / span 1',
            justifySelf: 'stretch',
            background:
              'linear-gradient(90deg, rgba(148, 163, 184, 0.30) 0%, rgba(148, 163, 184, 0.10) 100%)',
          }}
        />
      </div>

      {/* Dashboard Cards */}
      <div className="flex flex-col gap-2 md:gap-4">
        <MockCard badgeColor="green" />
        <MockCard badgeColor="blue" />
        <MockCard badgeColor="amber" />
      </div>
    </div>
  );
}
